<template>
  <div>
    <!--  -->

    <el-input
      placeholder="请输入URL"
      v-model="newValue"
      @input="handleChange"
      :class="desc.class"
      :style="desc.style"
      v-bind="desc.attrs"
      v-on="desc.on"
    >
      <template slot="prepend">URL:</template>
      <div class="body" slot="append">
        <el-upload
          slot="append"
          class="upload-demo"
          :action="action"
          :on-preview="handlePreview"
          :on-remove="handleRemove"
          :before-remove="beforeRemove"
          multiple
          :limit="1"
          :on-exceed="handleExceed"
          :file-list="fileList"
        >
          <el-tooltip
            content="只能上传jpg/png文件，且不超过500kb"
            placement="top"
          >
            <el-button size="small" type="primary">上传</el-button>
          </el-tooltip>
        </el-upload>
        <div class="fill"></div>
        <el-button slot="append" @click="LookPhoto">查看</el-button>
      </div>
    </el-input>
  </div>
</template>
<script>
import { formMixin } from "vue-ele-form";

export default {
  name: "custom-url", // name 属性必须填写, 在使用时, 需要和这里定义的 name 一致
  mixins: [formMixin], // 必须引入mixin
  props: {
    // value 是传递过来的值
    value: String,
    // desc是此组件的描述, 结构为
    // { style: {}, class: {}, on: {}, attrs: {} }
    desc: {
      type: Object,
      default() {
        return {
          action: "",
          fileList: [
            {
              name: "food.jpeg",
              url:
                "https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/100"
            },
            {
              name: "food2.jpeg",
              url:
                "https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/100"
            }
          ]
        };
      }
    }
  },
  data() {
    return {
      // 用于v-model绑定, 因为 v-model无法绑定props值
      newValue: this.value
    };
  },
  methods: {
    //   handleChange(value) {
    //     this.$emit('input', value) // 当值变化时, 一定要触发input事件
    //   },
    handleRemove(file, fileList) {},
    handlePreview(file) {},
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 3 个文件，本次选择了 ${
          files.length
        } 个文件，共选择了 ${files.length + fileList.length} 个文件`
      );
    },
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`);
    },
    LookPhoto() {},
    Submit() {}
  }
};
</script>
<style lang="scss">
.body {
  display: flex;
  .fill:nth-child(1) {
    height: 100%;
  }
  .fill {
    width: 10px;
  }
}
</style>
